import { useState } from "react";
import { useDispatch } from "react-redux";

import { setSection } from "../../../assignmentSlice";

import { typeInfo } from "../../../../../constants/typeInfo";
import { applyUnderline } from "../../../../../utils/textUtils";

import CommonPage from "../../common/CommonPage";

const BasicChoicePage = ({
  section,
  pageList,
  currentPage,
  currentIndex,
  setPageList,
  handlePreviousPage,
  handleNextPage,
}) => {
  const dispatch = useDispatch();

  const [overlayVisible, setOverlayVisible] = useState(false);

  const selectOption = ({ optionIndex }) => {
    const realIndex = optionIndex + 1;
    const isCorrect = realIndex === currentPage.answer;
    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          isCorrect,
          input: realIndex,
          isSubmitted: true,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));

    setOverlayVisible(true);
    setTimeout(() => {
      setOverlayVisible(false);
    }, 600);
  };

  return (
    <CommonPage
      currentIndex={currentIndex}
      currentPage={currentPage}
      handlePreviousPage={handlePreviousPage}
      handleNextPage={handleNextPage}
      totalNo={pageList.length}
      overlayVisible={overlayVisible}
      isCorrect={currentPage.isCorrect}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "75vw",
          gap: "30px",
        }}
      >
        <div
          style={{
            fontSize: "24px",
          }}
        >
          {applyUnderline(
            `${currentIndex + 1}. ${currentPage.question.replace(
              "적고, 틀린 표현들을 모두 올바른 표현으로 고치시오.",
              "고르세요."
            )}`
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "14px",
          }}
        >
          {currentPage.choices.map((option, optionIndex) => {
            return (
              <div
                key={optionIndex}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "16px 20px",
                  border: "1px solid #EBEBEB",
                  borderRadius: "5px",
                  fontWeight:
                    currentPage.isSubmitted &&
                    (optionIndex + 1 === currentPage.answer ||
                      optionIndex + 1 === currentPage.input)
                      ? "bold"
                      : "normal",
                  cursor: !currentPage.isSubmitted && "pointer",
                  backgroundColor:
                    currentPage.isSubmitted &&
                    currentPage.answer === optionIndex + 1
                      ? typeInfo["grammar"].backgroundColor
                      : currentPage.input === optionIndex + 1 &&
                        "rgba(240, 52, 52, 0.5)",
                  color:
                    currentPage.isSubmitted &&
                    currentPage.answer === optionIndex + 1
                      ? typeInfo["grammar"].color
                      : currentPage.input === optionIndex + 1 && "white",
                  fontSize: "18px",
                }}
                onClick={() => {
                  if (currentPage.isSubmitted) return;
                  selectOption({ optionIndex });
                }}
              >
                {option}
              </div>
            );
          })}
        </div>
        {currentPage.isSubmitted && currentPage.explanation && (
          <div
            style={{
              padding: "20px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              borderLeft: "4px solid #4CAF50",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                marginBottom: "8px",
                color: "#333",
              }}
            >
              해설
            </div>
            <div style={{ fontSize: "16px", lineHeight: "1.6", color: "#555" }}>
              {currentPage.explanation}
            </div>
          </div>
        )}
      </div>
    </CommonPage>
  );
};

export default BasicChoicePage;
